import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Community',
    path: '/community'
  }, {
    name: 'Careers',
    path: '/careers'
  }, {
    name: 'FAQ',
    path: '/faq'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#121212] shadow-lg py-3' : 'bg-[#121212] py-5'}`} data-id="element-74">
      <div className="container mx-auto px-4" data-id="element-75">
        <div className="flex items-center justify-between" data-id="element-76">
          {/* Logo - Enlarged to 1.5x with subtle gold glow */}
          <Link to="/" className="flex-shrink-0 transition-all duration-300 hover:scale-105" style={{
          filter: 'drop-shadow(0 0 8px rgba(139, 105, 20, 0.4))'
        }} data-id="element-77">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ibuVzkycDnA7HHUx1J6KA1/magnavera-logo.jpg" alt="Magnavera Group" className="h-16 md:h-20" data-id="element-78" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-79">
            {navLinks.map(link => <Link key={link.path} to={link.path} className="relative group py-2" data-id="element-80">
                <span className={`font-poppins font-medium text-sm tracking-wide transition-colors duration-300 ${location.pathname === link.path ? 'text-white' : 'text-gray-300 hover:text-white'}`} data-id="element-81">
                  {link.name}
                </span>
                {/* Refined underline animation with bronze color */}
                <span className={`absolute bottom-0 left-0 right-0 h-0.5 bg-[#8B6914] transition-all duration-300 ease-out ${location.pathname === link.path ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0 group-hover:opacity-100 group-hover:scale-x-100'}`} style={{
              transformOrigin: 'left'
            }} data-id="element-82"></span>
              </Link>)}

            <a href="tel:+6589701506" className="flex items-center text-[#8B6914] font-poppins font-medium ml-4 hover:text-[#A0826D] transition-colors duration-300" data-id="element-83">
              <PhoneIcon className="h-4 w-4 mr-2" data-id="element-84" />
              +65 8970 1506
            </a>

            <Link to="/contact" className="ml-2 bg-[#8B6914] text-white px-6 py-2.5 rounded-lg font-poppins font-medium text-sm uppercase tracking-wider transition-all duration-300 hover:bg-[#A0826D] hover:shadow-lg" style={{
            boxShadow: '0 0 0 rgba(139, 105, 20, 0)'
          }} onMouseEnter={e => {
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(139, 105, 20, 0.4)';
          }} onMouseLeave={e => {
            e.currentTarget.style.boxShadow = '0 0 0 rgba(139, 105, 20, 0)';
          }} data-id="element-85">
              Get in Touch
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-white p-2 hover:text-[#8B6914] transition-colors" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-86">
            {isMenuOpen ? <XIcon size={28} data-id="element-87" /> : <MenuIcon size={28} data-id="element-88" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && <nav className="md:hidden py-6 border-t border-gray-800 mt-4 animate-fadeIn" data-id="element-89">
            <ul className="space-y-5" data-id="element-90">
              {navLinks.map(link => <li key={link.path} data-id="element-91">
                  <Link to={link.path} className={`block font-poppins font-medium text-sm tracking-wide ${location.pathname === link.path ? 'text-[#8B6914]' : 'text-gray-300'}`} onClick={() => setIsMenuOpen(false)} data-id="element-92">
                    {link.name}
                  </Link>
                </li>)}
              <li data-id="element-93">
                <a href="tel:+6589701506" className="flex items-center text-[#8B6914] font-poppins font-medium" data-id="element-94">
                  <PhoneIcon className="h-4 w-4 mr-2" data-id="element-95" />
                  +65 8970 1506
                </a>
              </li>
              <li className="pt-2" data-id="element-96">
                <Link to="/contact" className="inline-block bg-[#8B6914] text-white px-6 py-2.5 rounded-lg font-poppins font-medium text-sm uppercase tracking-wider" onClick={() => setIsMenuOpen(false)} data-id="element-97">
                  Get in Touch
                </Link>
              </li>
            </ul>
          </nav>}
      </div>
    </header>;
};
export default Header;